interface ListingsGridFallbackProps {
    isGridView?: boolean;
    showFilters?: boolean;
    itemCount?: number;
}

export default function ListingsGridFallback({
    isGridView = true,
    showFilters = false,
    itemCount = 12
}: ListingsGridFallbackProps) {
    return (
        <div className="animate-pulse">
            <div className="h-12 bg-gray-200 rounded mb-6"></div>

            <div className="flex gap-6">
                {showFilters && (
                    <aside className="w-80 flex-shrink-0 hidden lg:block">
                        <div className="h-96 bg-gray-200 rounded"></div>
                    </aside>
                )}

                <div className="flex-1">
                    <div
                        className={`grid gap-6 mb-8 ${isGridView
                            ? "grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4"
                            : "grid-cols-1"
                            }`}
                    >
                        {Array.from({ length: itemCount }).map((_, i) => (
                            <div
                                key={i}
                                className={`bg-gray-200 rounded ${isGridView ? "h-80" : "h-32"}`}
                            />
                        ))}
                    </div>

                    <div className="flex justify-center items-center space-x-2">
                        <div className="w-20 h-9 bg-gray-200 rounded"></div>
                        {Array.from({ length: 5 }).map((_, i) => (
                            <div key={i} className="w-9 h-9 bg-gray-200 rounded"></div>
                        ))}
                        <div className="w-16 h-9 bg-gray-200 rounded"></div>
                    </div>
                </div>
            </div>
        </div>
    );
}